import Avatar1 from "../images/avatars/Avatar1.png"
import Avatar2 from "../images/avatars/Avatar2.png"
import Avatar3 from "../images/avatars/Avatar3.png"
import Avatar4 from "../images/avatars/Avatar4.png"
import Avatar5 from "../images/avatars/Avatar5.png"
import Avatar6 from "../images/avatars/Avatar6.png"
import Avatar7 from "../images/avatars/Avatar7.png"
import Avatar8 from "../images/avatars/Avatar8.png"
import Avatar9 from "../images/avatars/Avatar9.png"
import Avatar10 from "../images/avatars/Avatar10.png"
import Avatar11 from "../images/avatars/Avatar11.png"
import Avatar12 from "../images/avatars/Avatar12.png"
import Avatar13 from "../images/avatars/Avatar13.png"
import Avatar14 from "../images/avatars/Avatar14.png"
import Avatar15 from "../images/avatars/Avatar15.png"
import Avatar16 from "../images/avatars/Avatar16.png"
import Avatar17 from "../images/avatars/Avatar17.png"
import Avatar18 from "../images/avatars/Avatar18.png"
import Avatar19 from "../images/avatars/Avatar19.png"
import Avatar20 from "../images/avatars/Avatar20.png"
import Avatar21 from "../images/avatars/Avatar21.png"
import Avatar22 from "../images/avatars/Avatar22.png"
import Avatar23 from "../images/avatars/Avatar23.png"
import Avatar24 from "../images/avatars/Avatar24.png"

const service = {}

service.list = () => {
  return Promise.resolve([
    Avatar1,
    Avatar2,
    Avatar3,
    Avatar4,
    Avatar5,
    Avatar6,
    Avatar7,
    Avatar8,
    Avatar9,
    Avatar10,
    Avatar11,
    Avatar12,
    Avatar13,
    Avatar14,
    Avatar15,
    Avatar16,
    Avatar17,
    Avatar18,
    Avatar19,
    Avatar20,
    Avatar21,
    Avatar22,
    Avatar23,
    Avatar24
  ])
}

export const getAvatars = service.list

export default service
